import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class ActionTrigger extends BaseOption {
  static optionKey = "action-trigger";
  static ON_CLICK = "click";
  static WHEN_SHOWN = "shown";

  static userInterfaceComponent = {
    label: "Fire When",
    component: inspectorTools.RADIO_BAR,
    descriptionMessage:
      "Clicked shows a button. Shown renders nothing on the published page and fires the action each time "
      + "the element becomes visible; make Visible conditional to fire it only when the action applies, "
      + "e.g. while a channel has unread messages.",
    props: {
      options: [
        {
          label: "Clicked",
          value: ActionTrigger.ON_CLICK,
          tooltip: "",
        },
        {
          label: "Shown",
          value: ActionTrigger.WHEN_SHOWN,
          tooltip: "",
        },
      ],
    },
  };

  static defaultValue = ActionTrigger.ON_CLICK;
}
